module.exports = __webpack_public_path__ + "img/cocobank-logo.a1447e1a.png";